import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React, { useState, useCallback, useRef } from 'react';
import StandardMenuContent from '../StandardMenuContent';
import classnames from 'classnames';
import ScrollableContent from '../../../../ScrollableContent';
import ArrowUp from '@wix/da-ds/pkg/Icons/ArrowUp';
import ArrowDown from '@wix/da-ds/pkg/Icons/ArrowDown';
import s from './ScrollableMenuContent.scss';
const ScrollableMenuContent = (_param)=>{
    var { label , labelClassName , withScrollableArrows  } = _param, contentProps = _object_without_properties(_param, [
        "label",
        "labelClassName",
        "withScrollableArrows"
    ]);
    const [scrollTop, setScrollTop] = useState(0);
    const [distanceToBottom, setDistanceToBottom] = useState(0);
    const scrollableRef = useRef(null);
    const setScrollableRef = useCallback((node)=>{
        scrollableRef.current = node;
    }, []);
    const onScrolled = useCallback((top, bottom)=>{
        setScrollTop(top);
        setDistanceToBottom(bottom);
    }, []);
    const onScrollClick = useCallback((e, distance)=>{
        if (!scrollableRef.current) {
            return;
        }
        scrollableRef.current.scrollBy({
            top: distance,
            behavior: 'smooth'
        });
        e.stopPropagation();
    }, []);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, label && /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['label'], labelClassName, scrollTop > 0 && s['sticky'])
    }, label), /*#__PURE__*/ React.createElement(ScrollableContent, {
        className: classnames(s['scrollable-content'], scrollTop === 0 && s['top'], distanceToBottom === 0 && s['bottom']),
        onScrolled: onScrolled,
        innerRef: setScrollableRef
    }, /*#__PURE__*/ React.createElement(StandardMenuContent, _extends({}, contentProps), withScrollableArrows && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: s['scroll-arrow-up'],
        onClick: (e)=>onScrollClick(e, -200)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['scroll-arrow-clickable']
    }, /*#__PURE__*/ React.createElement(ArrowUp, {
        disableDefaultColors: true
    }))), /*#__PURE__*/ React.createElement("div", {
        className: s['scroll-arrow-down'],
        onClick: (e)=>onScrollClick(e, 200)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['scroll-arrow-clickable']
    }, /*#__PURE__*/ React.createElement(ArrowDown, {
        disableDefaultColors: true
    })))))));
};
ScrollableMenuContent.displayName = 'ScrollableMenuContent';
export default ScrollableMenuContent;
